import moment from 'moment';
import { DATE_FORMATS } from '../constants/globalConstants';

const formatDate = (date, format = DATE_FORMATS.TABLE_LONG) => {
	return moment(date).format(format);
};

export default formatDate;
